var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 81,
    viewBox: "0 0 139 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2892",
    "data-name": "Group 2892",
    transform: "translate(-510 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(633 460)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(510 501)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(625 536)",
    fill: "#0f0fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ca1436aefbb120eb603f5b157979e739.svg";
export { ForwardRef as ReactComponent };